<template lang="html">
	<div class="social-login" v-if="role === 'client'">
		<div class="social-login__line"></div>

		<div class="social-login__title">
			Sau conectare cu:
		</div>

		<div class="social-login__buttons">
			<GoogleLogin
				@click.native="clearForm"
				:params="google.params"
				:onSuccess="onSuccess"
				:onFailure="onFailure"
				class="social-login__google">
				<img src="../assets/images/google.png" class="social-login__google--icon" />
				<span class="social-login__google--title">Google</span>
			</GoogleLogin>
            
            <button  @click="logInWithFacebook" class="social-login__facebook">
                <img src="../assets/images/facebook.png" class="social-login__facebook--icon" />
                <span class="social-login__facebook--title">Facebook</span>
            </button>
		</div>
	</div>
</template>

<script>

import GoogleLogin from 'vue-google-login';
import config from '@/config.js'
import { mapActions, mapGetters } from 'vuex'

export default {
	components: { GoogleLogin },
	data() {
		return {
			google: {
				params: {
					client_id: config.GOOGLE_AUTH_ID
				}
			},
            role: 'client',
            fbSignInParams: {
                scope: 'public_profile,email',
                return_scopes: true
            }
		};
	},
	created() {
        if(this.$router.currentRoute.fullPath == '/specialist/login')
			this.role = 'specialist';
        else
			this.role = 'client';
    },
	methods: {
		...mapActions({
            connectWith: 'user/connectWith'
        }),
        clearForm() {
            this.$emit('clearForm');
        },
		onSuccess(googleUser) {
            var profile = googleUser.getBasicProfile();
            if(!profile) {
                this.$store.state.notification.notification = {
                    icon: 'error', title: 'A apărut o eroare la conectare.'
                };
                return;
            }
			this.connectWith({
                platform: 'google',
                payload: {
                    id: profile.getId(),
                    name: profile.getName(),
                    email: profile.getEmail(),
                    // image_url: profile.getImageUrl()
                }
            });
        },
        onFailure(err) {
            var messages = {
                popup_closed_by_user: 'Fereastra de înregistrare Google a fost închisă prea devreme.'
            };

            if(messages.hasOwnProperty(err.error))
                this.$store.state.notification.notification = {
                    icon: 'error',
                    title: messages[err.error]
                };
            else
                this.$store.state.notification.notification = {
                    icon: 'error',
                    title: 'A apărut o eroare la creearea contului utilizând Google.'
                };
        },
        async logInWithFacebook() {
			this.clearForm();
            // await this.loadFacebookSDK(document, "script", "facebook-jssdk");
            // await this.initFacebook();

            window.FB.login((response) => {
                if (response.authResponse) {
                    FB.api('/me?fields=id,name,email', (user) => {
                        this.connectWith({
                            platform: 'facebook',
                            payload: {
                                id: user.id,
                                name: user.name,
                                email: user.email?user.email:null
                            }
                        });
                    });
                } else {
                    this.$store.state.notification.notification = {
                        icon: 'error',
                        title: 'A apărut o eroare la conectare.'
                    };
                    return;
                }
            }, { scope: 'public_profile,email' });

            return false;
        },
        async initFacebook() {
            window.fbAsyncInit = () => {
                FB.init({
                    appId: config.FACEBOOK_AUTH_ID,
                    cookie: true,
                    xfbml: true,
                    version: 'v2.8'
                });

                FB.getLoginStatus(function(response) {
                    if (response && response.status == 'connected') {
                        FB.logout();
                    }
                }, true);
            };
        },
        async loadFacebookSDK(d, s, id) { // Load the SDK asynchronously
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }
	},
	async mounted() {
        await this.loadFacebookSDK(document, "script", "facebook-jssdk");
        await this.initFacebook();
    }
}
</script>

<style lang="scss">

.social-login {
    margin: 20px 0;
    text-align: center;

    &__title {
        margin: 20px auto;
        font-size: 15px;
        margin-bottom: 0;
    }

    &__line {
        margin: 10px auto;
        width: 100%;
        height: 1px;
        background-color: rgb(194, 220, 255);
    }

    &__buttons {
        width: 100%;
        margin: 20px auto;
        display: flex;
        justify-content: space-between;

        @include media-breakpoint-down(lg) {
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }

    &__google {
        width: 40%;
        min-width: 190px!important;
        height: 44px;
        padding: 7px 15px;
        display: flex;
        justify-content: space-around;
        background-color: $color-light;
        border: none;
        box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;
        cursor: pointer;

        @include media-breakpoint-down(lg) {
            width: 100%;
        }

        &--icon {
            width: 30px;
            height: 30px;
        }

        &--title {
            vertical-align: middle;
            font-size: 15px;
            font-family: 'Roboto', sans-serif;
            margin: auto;
            color: $color-main-text;
        }
    }

    &__facebook {
        width: 40%;
        min-width: 190px!important;
        height: 44px;
        padding: 7px 15px;
        display: flex;
        justify-content: space-around;
        background-color: $color-light;
        border: none;
        box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;
        cursor: pointer;

        @include media-breakpoint-down(lg) {
            width: 100%;
            margin-top: 10px;
        }

        &--icon {
            width: 30px;
            height: 30px;
        }

        &--title {
            vertical-align: middle;
            font-size: 15px;
            font-family: 'Roboto', sans-serif;
            margin: auto;
            color: $color-main-text;
        }
    }
}


// Facebook spinner button
// .spinner {
//     box-sizing: border-box;
//     width: 30px !important;
//     height: 30px !important;
//     border-radius: 50%;
//     border: 5px solid #f3f3f3;
//     border-top: 5px solid #3498db;
//     -webkit-animation: spin-data-v-0af1f3c3 2s linear infinite;
//     animation: spin-data-v-0af1f3c3 2s linear infinite;
//     position: absolute;
//     margin-left: 10px;
//     top: 7px !important;
// }
</style>
